import { useSyncCoworkerStore } from "@/authorization/useSyncCoworkerStore";
import { useActiveProject } from "@/features/project/ActiveProject";
import { type StoreConfig, useSettings } from "@repo/ui";
import isEmpty from "lodash/isEmpty";

import { useGrouppedAppointments } from "./useGrouppedAppointments";

const getZipCode = (
  allStores: StoreConfig[],
  cmpCode?: string,
  service?: string
) => {
  const store = allStores.find((el) => el.unit_id_key === cmpCode);
  const serviceConfig = store?.service_configs?.find(
    (el) => el.service_name_key === service
  );

  return !isEmpty(serviceConfig?.zip_code)
    ? serviceConfig?.zip_code
    : store?.zip_code;
};

const parseLink = (
  link: string,
  market: string,
  language: string,
  zip: string,
  service: string
) =>
  link
    .replace("${market}", market)
    .replace("${language}", language)
    .replace("${zip}", zip)
    .replace("${service}", service);

const getBokaLink = (
  market: string,
  language: string,
  service: string,
  zip?: string
) => {
  return `https://boka.ingka.com/${market}/${language}/operation/${
    !isEmpty(zip) ? `${zip}_` : ""
  }${service}/planner/`;
};

export const useBokaLink = (cmpCode?: string, service?: string) => {
  const { language, market, boka_config } = useSettings();
  const { link, cmpCode: defaultCmpCode } = useDefaultBokaLinkConfig();

  const zipCode = getZipCode(
    boka_config?.stores ?? [],
    cmpCode ?? defaultCmpCode,
    service
  );

  return parseLink(
    // if service is selected, use boka link. Otherwise use default link
    service ? getBokaLink(market, language, service, zipCode) : link,
    market,
    language,
    zipCode ?? "",
    service ?? ""
  );
};

export const useDefaultBokaLinkConfig = () => {
  const { opportunity } = useActiveProject();
  const { boka_config } = useSettings();
  const store = useSyncCoworkerStore();
  // last appointment
  const { lastBooked } = useGrouppedAppointments(opportunity?.id);

  const link =
    boka_config?.hfb_configuration?.hfb_list?.find(
      (l) => (l.hfb_code_key ?? l.hfb_code_key) === opportunity?.hfb?.[0]
    )?.boka_link ??
    boka_config?.hfb[opportunity?.hfb?.[0] ?? "hfb97"]?.boka_link ??
    "https://boka.ingka.com/${market}/${language}/operation/";
  const cmp = boka_config?.stores?.find(
    (el) => el.name === lastBooked?.locationName
  );
  return {
    link,
    cmpCode: cmp?.unit_id_key ?? store?.No,
  };
};
